export default __webpack_public_path__ + "f9b6d229f4edb38aac451cc7338a9d0f.gif";